import { FC, useState } from "react";
import css from './index.module.css';
import Popup from "@components/popup";
import { toast } from "sonner";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import TinyMceEditor from "@pages/admin/blog/editor";

interface Modal {
  showModal: boolean; 
  setShowModal: any;
}

export const CreateTicket:FC<Modal> = ({ showModal, setShowModal }) => {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  
  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.append('msg', message);

    axios.post(`${import.meta.env.VITE_API_URL}/support`, formData, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('authToken')
    }})
    .then(async (response) => {
      navigate(`/support/${response.data.id}`)
      toast.success('Обращение создано');
      setShowModal(false);
    });
  };

  return (
      <Popup showPopup={showModal} setShowPopup={setShowModal} width={700}>
        <h5 style={{ fontSize: '20px', marginBottom: 10, marginTop: 0 }}>Создать обращение</h5>

        <form onSubmit={handleSubmit} className={css.form}>
          <select name="type">
            <option value={0}>Вопрос</option>
            <option value={1}>Проблема</option>
            <option value={2}>Квоты</option>
          </select>

          <input name="topic" placeholder="Тема обращения" required />
          <TinyMceEditor initialValue={message} editorChange={setMessage} type={1} />

          <button type="submit">Создать обращение</button>
        </form>
      </Popup>
  );
}
